import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "acReminds" }
const _hoisted_2 = { class: "acReminds_header" }
const _hoisted_3 = { class: "acReminds_title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "acReminds_subTitle" }, null, -1)
const _hoisted_5 = { class: "acReminds_row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4353_14001)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M3.75 13.5H14.25V8.27325C14.25 5.361 11.8995 3 9 3C6.1005 3 3.75 5.361 3.75 8.27325V13.5ZM9 1.5C12.7275 1.5 15.75 4.53225 15.75 8.27325V15H2.25V8.27325C2.25 4.53225 5.2725 1.5 9 1.5ZM7.125 15.75H10.875C10.875 16.2473 10.6775 16.7242 10.3258 17.0758C9.97419 17.4275 9.49728 17.625 9 17.625C8.50272 17.625 8.02581 17.4275 7.67417 17.0758C7.32254 16.7242 7.125 16.2473 7.125 15.75Z",
      fill: "white"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4353_14001" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18",
        height: "18",
        rx: "4",
        fill: "white"
      })
    ])
  ])
], -1)
const _hoisted_7 = { class: "acReminds_row acReminds_content" }
const _hoisted_8 = {
  key: 0,
  class: "acReminds_loading"
}
const _hoisted_9 = { class: "acReminds_remind remind" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "remind_time" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "remind_icon -time" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4353_14009)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15ZM9.75 8.5C9.75 8.77614 9.97386 9 10.25 9H12C12.4142 9 12.75 9.33579 12.75 9.75C12.75 10.1642 12.4142 10.5 12 10.5H8.75C8.47386 10.5 8.25 10.2761 8.25 10V6C8.25 5.58579 8.58579 5.25 9 5.25C9.41421 5.25 9.75 5.58579 9.75 6V8.5Z",
        fill: "#3C92FE"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4353_14009" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_13 = { class: "remind_text" }
const _hoisted_14 = { class: "remind_date" }
const _hoisted_15 = { class: "remind_text" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "remind_icon -date" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4353_14011)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.75 2.25H15.75C15.9489 2.25 16.1397 2.32902 16.2803 2.46967C16.421 2.61032 16.5 2.80109 16.5 3V15C16.5 15.1989 16.421 15.3897 16.2803 15.5303C16.1397 15.671 15.9489 15.75 15.75 15.75H2.25C2.05109 15.75 1.86032 15.671 1.71967 15.5303C1.57902 15.3897 1.5 15.1989 1.5 15V3C1.5 2.80109 1.57902 2.61032 1.71967 2.46967C1.86032 2.32902 2.05109 2.25 2.25 2.25H5.25V0.75H6.75V2.25H11.25V0.75H12.75V2.25ZM15 8.25H3V14.25H15V8.25ZM11.25 3.75H6.75V5.25H5.25V3.75H3V6.75H15V3.75H12.75V5.25H11.25V3.75ZM4.5 10.5C4.5 10.0858 4.83579 9.75 5.25 9.75C5.66421 9.75 6 10.0858 6 10.5C6 10.9142 5.66421 11.25 5.25 11.25C4.83579 11.25 4.5 10.9142 4.5 10.5ZM8.25 10.5C8.25 10.0858 8.58579 9.75 9 9.75C9.41421 9.75 9.75 10.0858 9.75 10.5C9.75 10.9142 9.41421 11.25 9 11.25C8.58579 11.25 8.25 10.9142 8.25 10.5ZM12 10.5C12 10.0858 12.3358 9.75 12.75 9.75C13.1642 9.75 13.5 10.0858 13.5 10.5C13.5 10.9142 13.1642 11.25 12.75 11.25C12.3358 11.25 12 10.9142 12 10.5Z",
        fill: "#3C92FE"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4353_14011" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z",
    fill: "#F83C43"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_as_preloader = _resolveComponent("as-preloader")!
  const _component_settings_content = _resolveComponent("settings-content")!

  return (_openBlock(), _createBlock(_component_settings_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('reminderTraining')), 1),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ac_button, {
            class: "acReminds_add",
            onClick: _ctx.addNotification
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('addNotification' )), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_as_preloader, { type: "circle" })
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.scheduleList, (schedule) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: schedule.id,
                  class: "acReminds_reminds reminds"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "remind_wrapper",
                      onClick: ($event: any) => (_ctx.openSchedule(schedule.id))
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(schedule.time), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(schedule.days), 1),
                        _hoisted_16
                      ])
                    ], 8, _hoisted_10),
                    _createElementVNode("div", {
                      class: "remind_remove",
                      onClick: ($event: any) => (_ctx.removeSchedule(schedule.id))
                    }, _hoisted_19, 8, _hoisted_17)
                  ])
                ]))
              }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}